import React, { FC, useState } from 'react';
import Breadcrumbs from 'shared/components/breadcrumbs/Breadcrumbs';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import ModalCancelSubmit from 'shared/components/modalCancelSubmit/ModalCancelSubmit';
import style from './index.module.scss';

type TProps = {
  id?: string | number;
  archiveNews: () => void;
  publicate: () => void;
  navigate: (where: string) => void;
  isUpdateStatusLoading?: boolean;
};

const TopBlock: FC<TProps> = ({ id, archiveNews, publicate, navigate, isUpdateStatusLoading }) => {
  const [openCancelModal, setOpenCanelModal] = useState<boolean>(false);
  const breadCrumbs = [
    { name: 'Новости', link: '/news' },
    { name: 'Редактировать новость', link: `/news/update/${id}` },
  ];

  const onSubmitCancelModal = () => {
    setOpenCanelModal(false);
    navigate('/news');
  };

  const onCancelCancelModal = () => {
    setOpenCanelModal(false);
  };

  const cancelModalOpen = () => {
    setOpenCanelModal(true);
  };

  return (
    <div className={style['top-block']}>
      <h3 className={style.breadCrumbs}>
        <Breadcrumbs breadCrumbs={breadCrumbs} />
      </h3>
      <div className={style.buttons}>
        <Button type="primary" onClick={publicate} loading={isUpdateStatusLoading}>
          Опубликовать
        </Button>
        <Button onClick={archiveNews} loading={isUpdateStatusLoading}>
          <DeleteOutlined />
          Удалить
        </Button>
        <Button onClick={cancelModalOpen}>Отмена</Button>
        <ModalCancelSubmit open={openCancelModal} onQuit={onSubmitCancelModal} onStay={onCancelCancelModal} />
      </div>
    </div>
  );
};

export default TopBlock;
